import type { PipelineTile } from "../api";
import { ragTone } from "../tone";
import { toneDotClass } from "./measure";

/**
 * A gate between steps (`step: null`, key starting `g` or `pg`) — a small
 * rotated-square diamond inline between the steps it sits between in
 * `stage_order`, with its short id and a tiny caption beneath (UX-mockup
 * prototype v2, frame 1 `.gt`/`.dia`) — never a loose pill. Same `ragTone`
 * mapping as `StepTile`.
 */
export function GateMarker({ gate, onOpen }: { gate: PipelineTile; onOpen: (stageKey: string) => void }) {
  const tone = ragTone(gate.overall_rag);
  return (
    <button
      type="button"
      data-nonmutating
      data-gate={gate.stage_key}
      data-tone={tone}
      onClick={() => onOpen(gate.stage_key)}
      aria-label={`${gate.label}: ${gate.overall_rag}`}
      className="flex shrink-0 flex-col items-center gap-1 px-1 text-center"
    >
      <span
        aria-hidden
        className={`h-3 w-3 rotate-45 rounded-[2px] border-2 ${
          tone === "neutral" ? "border-ks-grey-3 bg-ks-surface" : `border-transparent ${toneDotClass(tone)}`
        }`}
      />
      <span className="text-[10px] font-bold text-ks-grey-1">{gate.label}</span>
    </button>
  );
}
